import {
	AuthenticationContext,
	AuthenticationContextStoreState,
} from '../types/authenticationContext.types';

export const selectAuthenticationContext = (
	state: AuthenticationContextStoreState,
): AuthenticationContext => state.authenticationContext;

export const selectTeams = (state: AuthenticationContextStoreState) =>
	selectAuthenticationContext(state)?.teams ?? [];
